import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=08243f54&scoped=true&"
import script from "./ReadMore.vue?vue&type=script&lang=js&"
export * from "./ReadMore.vue?vue&type=script&lang=js&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=08243f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08243f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08243f54')) {
      api.createRecord('08243f54', component.options)
    } else {
      api.reload('08243f54', component.options)
    }
    module.hot.accept("./ReadMore.vue?vue&type=template&id=08243f54&scoped=true&", function () {
      api.rerender('08243f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/ReadMore.vue"
export default component.exports